import { FC } from 'react';
import styles from './index.module.less';
import Link from '@base/lib/ThemeLink';
import { IVariant } from 'base/interfaces/product';
import { useTrans } from 'base/utils/i18n';

type IProdViewMoreProps = {
    shownVariant: IVariant;
}

export const ProdViewMore: FC<IProdViewMoreProps> = props => {
    const { shownVariant } = props;
    const { t } = useTrans();
    return (
        <div className={styles.more}>
            <Link href={shownVariant.url}>
                <a>
                    {t('web_product_view_full_info')}
                </a>
            </Link>
        </div>
    )
};
